import moment from 'moment';
import isEqual from 'lodash/isEqual';
import sum from 'lodash/sum';
import range from 'lodash/range';

function isDate(test) {
  if (typeof test === 'string') {
    return moment(test, moment.ISO_8601, true).isValid();
  }
  return moment.isDate(test) || moment.isMoment(test);
}

function isPrimitive(test) {
  return (test !== Object(test));
}

function compare(before, after) {
  if (isEqual(before, after)) return 0;
  if (DEBUG) {
    console.log(before, '!==', after);
  }
  return before || after ? 1 : 0;
}

export default function difference(before, after) {
  if (isDate(before) && isDate(after)) {
    return compare(moment(before).valueOf(), moment(after).valueOf());
  }
  if (Array.isArray(before) && Array.isArray(after)) {
    if (isPrimitive(before[0])) {
      return compare(before, after);
    }
    return sum(range(0, Math.max(before.length, after.length)).map(i => difference(before[i], after[i])));
  }
  if (before && after && typeof before === 'object' && typeof after === 'object') {
    return sum(Object.keys(before).map((key) => {
      if (/^\$\$/.test(key)) return 0;
      return difference(before[key], after[key]);
    }));
  }
  return compare(before, after);
}



// WEBPACK FOOTER //
// ../utils/difference.js